export interface NfcReaderSettings {
  enabled: boolean;
}
